import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import Alert from 'react-bootstrap/Alert';
import LoginForm from './LoginForm.js'
import {Redirect } from "react-router-dom";
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { securityConstants } from '../../constants';

class LoginPage extends Component {

  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      loggingOut: true,
      submitted: false,
      new_user: false
    }
  }

  componentDidMount() {
    // If the user
    axios.delete(`${this.props.api_url}/logout`)
      .finally(() => {
        this.setState({ loggingOut: false })
        localStorage.setItem("google_maps_api_key", null)
      });
  }

  renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div>
      <label>{label}</label>
      <div>
        <input {...input} placeholder={label} type={type} />
        {touched && error && <span>{error}</span>}
      </div>
    </div>
  );

   handleSubmit = (values) => {
      const config = { headers: { 'content-type': 'application/json' } }
      let URL = `${this.props.api_url}/login`
      axios.post(URL, {"user_info":values}, config)
        .then(response =>{
          if (response.data.error){
            this.setState({ 
              failed: true,
              error_message:response.data.message
            })
          }
          else {
            const details = jwt_decode(response.data.access_token);

            localStorage.setItem('user_id', details.sub);
            localStorage.setItem('role', details.role);
            localStorage.setItem('google_maps_api_key', details.google_maps_api_key);

            if (details.role === securityConstants.role.ADMIN) {
              this.setState({admin_user: true})
            } else if (response.data.new_user) {
              this.setState({new_user: true})
            } else {
              this.setState({submitted: true})
            }
          }})
        .catch((error) => {
          this.setState({
            failed: true,
            error_message: (error && error.response && error.response.data) || 'Failed to login with unknown error',
          });
          console.log(error);
        })
    }

   clearErrors = () => {
     this.setState({
       failed: false,
       error_message: null,
     });
   }

  render() {
    if (this.state.loggingOut) {
      return (<h2>Loading...</h2>);
    }

    if (this.state.admin_user){
        return <Redirect to='/ad/dashboard'/>
    }
    if (this.state.new_user===true){
      return <Redirect to='/ru/configureprofile'/>
    }
    if (this.state.submitted===true){
      return <Redirect to='/ru/list'/>
    }
    localStorage.removeItem('uk_spectrum_token');
    return (
      <>
        { this.state.failed && this.state.error_message &&
          <Alert variant="danger" onClose={this.clearErrors} dismissible>
            {this.state.error_message}
          </Alert>
        }
        <LoginForm onSubmit={this.handleSubmit}/>
      </>
    );
  };
}

LoginPage = reduxForm({
  form: 'loginpage', //Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
})(LoginPage)

export default LoginPage;
